import { render, staticRenderFns } from "./endWarnModal.vue?vue&type=template&id=06586cd6&scoped=true"
import script from "./endWarnModal.vue?vue&type=script&lang=js"
export * from "./endWarnModal.vue?vue&type=script&lang=js"
import style0 from "./endWarnModal.vue?vue&type=style&index=0&id=06586cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06586cd6",
  null
  
)

export default component.exports